import { ThemeOptions } from '@mui/material';
import * as _ from 'lodash-es';

export const themeInput: ThemeOptions['components'] = {
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: '0.875rem',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        '& .MuiFormLabel-root': {
          color: theme.palette.text.primary,
        },
        '& .MuiInputBase-root.Mui-error': {
          backgroundColor: theme.palette.error.light,
        },
        '& .MuiInputBase-root.Mui-disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
          borderRadius: _.isEmpty(ownerState.label) ? '4px' : '8px',
          height: _.isEmpty(ownerState.label) ? '42px' : '46px',
        },
      }),
    },
  },
};
